/* PERAL — interacciones del tema (logo animado, catálogo, carrito AJAX, producto) */
(function () {
  "use strict";

  var P = window.PERAL || { routes: { root: "/", cart: "/cart", cartAdd: "/cart/add", cartChange: "/cart/change" }, cartType: "drawer", strings: {} };
  var S = P.strings || {};
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return [].slice.call((ctx || document).querySelectorAll(sel)); }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function smooth(t) { return t * t * (3 - 2 * t); }
  function ramp(p, a, b) { if (b <= a) return p >= b ? 1 : 0; return smooth(clamp((p - a) / (b - a), 0, 1)); }
  function norm(s) { return String(s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, ""); }
  function root(path) { return (P.routes.root || "/").replace(/\/$/, "") + path; }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $("#toast"); if (!t) return;
    t.textContent = msg; t.classList.add("on");
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove("on"); }, 2600);
  }

  /* =====================================================================
     HEADER — fondo sólido, barra de progreso, menú móvil, enlaces activos
     ===================================================================== */
  var chrome = $("#chrome"), meter = $("#meter"), mnav = $("#mnav"), menuBtn = $("#menuBtn");
  var isHome = document.body.classList.contains("is-home");

  function setMenu(on) {
    if (!mnav || !menuBtn) return;
    mnav.classList.toggle("open", on);
    mnav.setAttribute("aria-hidden", on ? "false" : "true");
    menuBtn.setAttribute("aria-expanded", on ? "true" : "false");
    menuBtn.setAttribute("aria-label", on ? "Cerrar menú" : "Abrir menú");
    if (chrome) chrome.classList.toggle("menu-open", on);
    document.documentElement.style.overflow = on ? "hidden" : "";
  }
  if (menuBtn) menuBtn.addEventListener("click", function () { setMenu(!mnav.classList.contains("open")); });

  /* Enlaces /#seccion: en el inicio hacen scroll suave en vez de recargar */
  function hashTarget(a) {
    var href = a.getAttribute("href") || "";
    var i = href.indexOf("#"); if (i < 0) return null;
    var path = href.slice(0, i);
    if (path && path !== "/" && path !== location.pathname && path !== (P.routes.root || "/")) return null;
    var id = decodeURIComponent(href.slice(i + 1));
    return id ? document.getElementById(id) : null;
  }
  document.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest("a[href*='#']");
    if (!a || a.target === "_blank") return;
    var el = hashTarget(a); if (!el) return;
    e.preventDefault();
    setMenu(false);
    closeDrawer();
    el.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
    history.replaceState(null, "", "#" + el.id);
  });

  var navLinks = $$(".nav a[href*='#'], .mnav a[href*='#']");
  var sectionIds = navLinks.map(function (a) { var el = hashTarget(a); return el ? el.id : null; }).filter(Boolean);
  var current = "";
  function markActive() {
    if (!isHome || !sectionIds.length) return;
    var line = window.innerHeight * 0.4, cur = "";
    sectionIds.forEach(function (id) { var el = document.getElementById(id); if (el && el.getBoundingClientRect().top <= line) cur = id; });
    if (cur === current) return; current = cur;
    navLinks.forEach(function (a) {
      var el = hashTarget(a), on = !!el && el.id === cur;
      a.classList.toggle("active", on);
      if (on) a.setAttribute("aria-current", "true"); else a.removeAttribute("aria-current");
    });
  }

  /* =====================================================================
     HERO — el logo se dibuja con el scroll (portado del diseño original)
     ===================================================================== */
  var H = null;
  function initHero() {
    var hero = $("[data-hero]");
    if (!hero) { H = null; return; }
    var q = function (s) { return $(s, hero); };
    var panels = $$("[data-panel]", hero), n = panels.length || 1;
    // Cada mensaje ocupa un tramo del scroll; entre tramos queda solo el logo.
    var cues = panels.map(function (_, i) {
      var seg = 1 / n, a = i * seg;
      if (i === 0) return [0, 0, seg * 0.45, seg * 0.69];
      var inS = a + seg * 0.05, inE = a + seg * 0.29;
      if (i === n - 1) return [inS, inE, 1.1, 1.2];
      return [inS, inE, a + seg * 0.71, a + seg * 0.95];
    });
    H = {
      el: hero, panels: panels, cues: cues,
      art: q("[data-art]"), glow: q("[data-glow]"), grad: q("[data-grad]"), hint: q("[data-hint]"),
      body: q('[data-part="body"]'), inner: q('[data-part="inner"]'), stem: q('[data-part="stem"]'),
      leaf: q('[data-part="leaf"]'), drop: q('[data-part="drop"]'),
      progress: 0, drawn: 0, lastDrawn: -1, lastProgress: -1
    };
  }
  function setDraw(el, t) { if (!el) return; el.style.strokeDashoffset = 1 - t; el.style.opacity = t > 0.002 ? 1 : 0; }
  function paintArt(p) {
    var leaf = ramp(p, 0.58, 0.72), drop = ramp(p, 0.70, 0.86);
    setDraw(H.body, ramp(p, 0.02, 0.40));
    setDraw(H.inner, ramp(p, 0.22, 0.55));
    setDraw(H.stem, ramp(p, 0.48, 0.62));
    if (H.leaf) {
      var ls = 0.2 + 0.8 * leaf;
      H.leaf.setAttribute("transform", "translate(24 9.5) rotate(" + (-28 * (1 - leaf)) + ") scale(" + ls + ") translate(-24 -9.5)");
      H.leaf.firstElementChild.style.opacity = leaf;
    }
    if (H.drop) {
      var dx = 2.6 * (1 - drop), dy = -5 * (1 - drop), ds = 0.4 + 0.6 * drop;
      H.drop.setAttribute("transform", "translate(" + dx + " " + dy + ") translate(7.5 13) scale(" + ds + ") translate(-7.5 -13)");
      H.drop.firstElementChild.style.opacity = drop;
    }
    if (H.grad) H.grad.setAttribute("gradientTransform", "translate(" + ((p - 0.5) * 34).toFixed(2) + " 0)");
    if (H.art) H.art.style.setProperty("--s", (0.94 + 0.06 * p).toFixed(4));
    if (H.glow) H.glow.style.opacity = (0.25 + 0.75 * ramp(p, 0.4, 0.9)).toFixed(3);
  }
  function paintPanels() {
    H.panels.forEach(function (el, i) {
      var c = H.cues[i], enter = ramp(H.progress, c[0], c[1]), leave = ramp(H.progress, c[2], c[3]);
      var o = enter * (1 - leave), y = (1 - enter) * 22 - leave * 22;
      el.style.opacity = o;
      el.style.transform = "translate3d(0," + y + "px,0)";
      el.style.pointerEvents = o > 0.6 ? "auto" : "none";
    });
    if (H.hint) H.hint.style.opacity = 1 - ramp(H.progress, 0, 0.06);
  }

  var pageProgress = 0;
  function readScroll() {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    pageProgress = max > 0 ? clamp(window.pageYOffset / max, 0, 1) : 0;
    if (H) {
      var span = H.el.offsetHeight - window.innerHeight, top = H.el.getBoundingClientRect().top;
      H.progress = span > 0 ? clamp(-top / span, 0, 1) : 0;
      if (chrome) chrome.classList.toggle("solid", top < -span + 8);
    } else if (chrome) {
      chrome.classList.toggle("solid", window.pageYOffset > 8);
    }
    markActive();
  }
  function frame() {
    if (H) {
      var target = reduceMotion ? 1 : H.progress, gap = target - H.drawn;
      if (Math.abs(gap) > 0.0005) H.drawn += gap * 0.115; else H.drawn = target;
      if (H.drawn !== H.lastDrawn) { paintArt(H.drawn); H.lastDrawn = H.drawn; }
      if (H.progress !== H.lastProgress) { paintPanels(); H.lastProgress = H.progress; }
    }
    if (meter) meter.style.transform = "scaleX(" + pageProgress + ")";
    requestAnimationFrame(frame);
  }
  window.addEventListener("scroll", readScroll, { passive: true });
  window.addEventListener("resize", readScroll);

  /* =====================================================================
     CATÁLOGO DEL INICIO — filtros por colección, búsqueda, stock y orden
     ===================================================================== */
  var C = null;
  function initCatalog() {
    var box = $("[data-catalog]");
    if (!box) { C = null; return; }
    var grid = $("[data-catalog-grid]", box);
    C = {
      box: box, grid: grid, cards: $$("[data-card]", grid),
      empty: $("[data-no-results]", grid), note: $("[data-result-note]", box),
      search: $("[data-catalog-search]", box), stock: $("[data-catalog-stock]", box), sort: $("[data-catalog-sort]", box),
      filter: "all", query: "", stockF: "all", sortBy: "featured"
    };
    if (!C.cards.length) { C = null; return; }
    $$(".chip", box).forEach(function (b) {
      b.addEventListener("click", function () { C.filter = b.getAttribute("data-filter"); renderCatalog(); });
    });
    if (C.search) C.search.addEventListener("input", function () { setQuery(this.value, this); });
    if (C.stock) C.stock.addEventListener("change", function () { C.stockF = this.value; renderCatalog(); });
    if (C.sort) C.sort.addEventListener("change", function () { C.sortBy = this.value; renderCatalog(); });
    renderCatalog();
  }
  function setQuery(q, from) {
    if (!C) return;
    C.query = q;
    $$("[data-live-search], [data-catalog-search]").forEach(function (el) { if (el !== from && el.value !== q) el.value = q; });
    renderCatalog();
  }
  function renderCatalog() {
    var q = norm(C.query).trim(), shown = 0;
    var list = C.cards.filter(function (c) {
      var ok = true;
      if (C.filter !== "all" && (" " + c.dataset.cols + " ").indexOf(" " + C.filter + " ") < 0) ok = false;
      if (ok && C.stockF !== "all" && c.dataset.state !== C.stockF) ok = false;
      if (ok && q && norm(c.dataset.search).indexOf(q) < 0) ok = false;
      c.hidden = !ok; if (ok) shown++;
      return ok;
    });
    list.sort(function (a, b) {
      var pa = +a.dataset.price, pb = +b.dataset.price;
      if (C.sortBy === "price-asc") return pa - pb;
      if (C.sortBy === "price-desc") return pb - pa;
      if (C.sortBy === "name") return a.dataset.name.localeCompare(b.dataset.name, "es");
      var ao = a.dataset.state === "out", bo = b.dataset.state === "out";
      if (ao !== bo) return ao ? 1 : -1;
      if (a.dataset.featured !== b.dataset.featured) return b.dataset.featured - a.dataset.featured;
      return a.dataset.index - b.dataset.index;
    });
    list.forEach(function (c) { C.grid.insertBefore(c, C.empty); });
    if (C.empty) C.empty.hidden = shown > 0;
    $$(".chip", C.box).forEach(function (b) { b.setAttribute("aria-pressed", b.getAttribute("data-filter") === C.filter ? "true" : "false"); });
    if (C.note) {
      var chip = $('.chip[data-filter="' + C.filter + '"]', C.box);
      C.note.textContent = shown + " " + (shown === 1 ? "producto" : "productos") +
        (C.filter !== "all" && chip ? " en " + chip.textContent : "") + (C.query ? " para “" + C.query + "”" : "");
    }
  }
  // Buscador del encabezado: en el inicio filtra la grilla en vivo; en otras páginas busca en /search
  $$("[data-live-search]").forEach(function (el) {
    el.addEventListener("input", function () {
      if (!C) return;
      setQuery(el.value, el);
      var top = C.box.getBoundingClientRect().top;
      if (top > window.innerHeight * 0.5 || top < -C.box.offsetHeight + 200) C.box.scrollIntoView({ behavior: "auto" });
    });
    el.form && el.form.addEventListener("submit", function (e) {
      if (!C) return;
      e.preventDefault(); setMenu(false);
      C.box.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth" });
    });
  });
  // Tarjetas de colección: en el inicio filtran la grilla
  document.addEventListener("click", function (e) {
    var card = e.target.closest && e.target.closest("[data-jump]");
    if (!card || !C) return;
    var handle = card.getAttribute("data-jump");
    if (!$('.chip[data-filter="' + handle + '"]', C.box) && !C.cards.some(function (c) { return (" " + c.dataset.cols + " ").indexOf(" " + handle + " ") > -1; })) return;
    e.preventDefault();
    C.filter = handle; renderCatalog();
    C.box.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth" });
  });
  document.addEventListener("click", function (e) {
    if (!C || !e.target.closest("[data-reset-filters]")) return;
    C.filter = "all"; C.stockF = "all"; if (C.stock) C.stock.value = "all"; setQuery("", null);
  });

  /* =====================================================================
     CARRITO — API AJAX de Shopify + Section Rendering API
     ===================================================================== */
  var drawer = null, lastFocus = null;
  function getDrawer() { drawer = $("#drawer"); return drawer; }
  function openDrawer() {
    if (!getDrawer()) { location.href = P.routes.cart; return; }
    lastFocus = document.activeElement;
    drawer.classList.add("open"); drawer.setAttribute("aria-hidden", "false");
    var scrim = $("#scrim"); if (scrim) scrim.classList.add("on");
    document.documentElement.style.overflow = "hidden";
    var x = $(".x", drawer); if (x) x.focus({ preventScroll: true });
  }
  function closeDrawer() {
    if (!getDrawer() || !drawer.classList.contains("open")) return;
    drawer.classList.remove("open"); drawer.setAttribute("aria-hidden", "true");
    var scrim = $("#scrim"); if (scrim) scrim.classList.remove("on");
    document.documentElement.style.overflow = "";
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function renderDrawer(html) {
    if (!html || !getDrawer()) return;
    var doc = new DOMParser().parseFromString(html, "text/html");
    var fresh = doc.getElementById("drawer");
    if (!fresh) return;
    drawer.innerHTML = fresh.innerHTML;
    var count = fresh.getAttribute("data-count");
    drawer.setAttribute("data-count", count);
    $$("#cartCount").forEach(function (c) {
      c.textContent = count;
      c.classList.remove("bump"); void c.offsetWidth; c.classList.add("bump");
    });
  }
  function cartFetch(url, body) {
    body.sections = "cart-drawer";
    body.sections_url = location.pathname;
    return fetch(url + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw new Error(data.description || data.message || S.error);
        return data;
      });
    });
  }
  function addToCart(id, qty, button) {
    if (P.cartType === "page" || !$("#drawer")) return false;
    if (button) button.classList.add("is-loading");
    cartFetch(P.routes.cartAdd, { items: [{ id: +id, quantity: qty || 1 }] })
      .then(function (data) {
        if (data.sections) renderDrawer(data.sections["cart-drawer"]);
        var title = data.items && data.items[0] ? data.items[0].product_title : "";
        if (button) { button.classList.add("ok"); setTimeout(function () { button.classList.remove("ok"); }, 1200); }
        if (P.cartType === "drawer") openDrawer(); else toast((S.added || "Agregado:") + " " + title);
      })
      .catch(function (err) { toast(err.message || S.error); })
      .then(function () { if (button) button.classList.remove("is-loading"); });
    return true;
  }
  function changeLine(key, qty) {
    var items = getDrawer() && $("#cartItems", drawer);
    if (items) items.classList.add("is-loading");
    cartFetch(P.routes.cartChange, { id: key, quantity: qty })
      .then(function (data) { if (data.sections) renderDrawer(data.sections["cart-drawer"]); })
      .catch(function (err) { toast(err.message || S.error); if (items) items.classList.remove("is-loading"); });
  }

  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (f.matches("[data-add-form]")) {
      var id = f.querySelector('[name="id"]').value;
      if (addToCart(id, 1, f.querySelector("button"))) e.preventDefault();
    } else if (f.matches("[data-product-form]")) {
      var vid = f.querySelector('[name="id"]').value, q = +(f.querySelector('[name="quantity"]').value || 1);
      if (addToCart(vid, q, f.querySelector("[data-add-btn]"))) e.preventDefault();
    }
  });
  document.addEventListener("click", function (e) {
    var t = e.target;
    var opener = t.closest && t.closest("[data-open-cart]");
    if (opener && P.cartType !== "page" && $("#drawer") && !document.body.classList.contains("template-cart")) {
      e.preventDefault(); setMenu(false); openDrawer(); return;
    }
    if (t.closest && t.closest("#drawer [data-qty]")) {
      var b = t.closest("[data-qty]");
      changeLine(b.getAttribute("data-key"), +b.getAttribute("data-qty"));
      return;
    }
    if (t.closest && t.closest("[data-close]") && (t.closest("#drawer") || t.id === "scrim")) closeDrawer();
  });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (drawer && drawer.classList.contains("open")) closeDrawer();
    else if (mnav && mnav.classList.contains("open")) setMenu(false);
  });

  /* =====================================================================
     PÁGINA DE PRODUCTO — variantes, galería, cantidad, stock
     ===================================================================== */
  function initProduct() {
    var root = $("[data-product]"); if (!root) return;
    var sec = root.closest("section") || document;
    var variants = []; try { variants = JSON.parse($("[data-variants]", sec).textContent); } catch (e) {}
    var low = 3; try { low = +JSON.parse($("[data-low]", sec).textContent) || 3; } catch (e) {}
    var form = $("[data-product-form]", root), idInput = $("[data-variant-id]", root);
    var qtyIn = $("[data-qty]", root), qtyOut = $("[data-qty-out]", root);
    var addBtn = $("[data-add-btn]", root), priceEl = $("[data-price]", root), stockEl = $("[data-stock]", root);
    var main = $("[data-main-media]", root);
    var current = variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || variants[0];

    function maxQty() { return current && current.qty !== null ? Math.max(current.qty, 0) : 99; }
    function setQty(n) {
      n = clamp(n, 1, Math.max(1, maxQty()));
      qtyIn.value = n; qtyOut.textContent = n;
      $$("[data-step]", root).forEach(function (b) {
        b.disabled = (+b.getAttribute("data-step") < 0 && n <= 1) || (+b.getAttribute("data-step") > 0 && n >= maxQty());
      });
    }
    function showImage(src, srcset, alt) {
      if (!main || !src) return;
      var img = $("img", main);
      if (!img) { img = document.createElement("img"); var svg = $("svg", main); if (svg) svg.remove(); main.appendChild(img); }
      img.src = src; if (srcset) img.srcset = srcset; else img.removeAttribute("srcset");
      img.alt = alt || img.alt;
    }
    function render() {
      if (!current) return;
      idInput.value = current.id;
      priceEl.innerHTML = (current.compare ? "<s>" + current.compare + "</s>" : "") + current.price;
      var st = !current.available ? "out" : current.qty !== null && current.qty <= low ? "low" : "in";
      stockEl.className = "stock " + st;
      stockEl.textContent = st === "out" ? "Agotado" : st === "low" ? (current.qty === 1 ? "¡Última unidad!" : "Quedan " + current.qty + " unidades") : "Disponible";
      addBtn.disabled = !current.available;
      addBtn.textContent = current.available ? "Agregar al carrito" : "Agotado";
      var nt = $("[data-notify]", root); if (nt) nt.hidden = !!current.available;
      var wa = $("[data-wa]", root); if (wa) wa.hidden = !current.available;
      var eta = $("[data-eta]", root); if (eta) { eta.setAttribute("data-available", current.available ? "true" : "false"); eta.hidden = !current.available; }
      var sku = $("[data-sku]", root); if (sku) sku.textContent = current.sku || "";
      if (current.image) showImage(current.image);
      setQty(+qtyIn.value || 1);
      // marca valores sin stock
      var opts = $$("[data-option]", root);
      opts.forEach(function (inp) {
        var idx = +inp.getAttribute("data-option");
        var exists = variants.some(function (v) {
          return v.available && v.options[idx] === inp.value && v.options.every(function (o, j) { return j === idx || o === current.options[j]; });
        });
        inp.classList.toggle("unavailable", !exists);
      });
      if (history.replaceState && variants.length > 1) {
        var u = new URL(location.href); u.searchParams.set("variant", current.id); history.replaceState(null, "", u.toString());
      }
    }
    $$("[data-option]", root).forEach(function (inp) {
      inp.addEventListener("change", function () {
        var chosen = $$("[data-option]:checked", root).map(function (i) { return i.value; });
        var match = variants.filter(function (v) { return v.options.every(function (o, j) { return o === chosen[j]; }); })[0];
        if (match) { current = match; render(); }
        else { addBtn.disabled = true; addBtn.textContent = "No disponible"; stockEl.className = "stock out"; stockEl.textContent = "Combinación no disponible"; }
      });
    });
    $$("[data-step]", root).forEach(function (b) {
      b.addEventListener("click", function () { setQty((+qtyIn.value || 1) + (+b.getAttribute("data-step"))); });
    });
    $$("[data-thumb]", root).forEach(function (b) {
      b.addEventListener("click", function () {
        showImage(b.getAttribute("data-src"), b.getAttribute("data-srcset"), b.getAttribute("data-alt"));
        $$("[data-thumb]", root).forEach(function (x) { x.setAttribute("aria-current", x === b ? "true" : "false"); });
      });
    });
    render();
  }

  function initRecommendations() {
    $$("[data-recommendations]").forEach(function (box) {
      if (box.dataset.loaded) return; box.dataset.loaded = "1";
      var load = function () {
        fetch(box.getAttribute("data-url")).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var fresh = doc.querySelector("[data-recommendations]");
          if (fresh && fresh.innerHTML.trim()) box.innerHTML = fresh.innerHTML;
        }).catch(function () {});
      };
      if ("IntersectionObserver" in window) {
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: "600px 0px" });
        io.observe(box);
      } else load();
    });
  }

  /* ---------- formularios que se envían solos (orden, filtros, cantidades del carrito) ---------- */
  document.addEventListener("change", function (e) {
    var t = e.target;
    if (t.matches("[data-autosubmit], [data-facets] input[type=checkbox]")) t.form.submit();
    if (t.matches("[data-autosubmit-change]")) t.form.submit();
  });

  /* =====================================================================
     LIBRO DE RECLAMACIONES — número de hoja y constancia para el cliente
     ===================================================================== */
  function initLibro() {
    var form = $("[data-libro]"); if (!form) return;
    var KEY = "peral-lr-copy";
    var done = $("[data-lr-done]", form);
    if (done) {
      var copy = $("[data-lr-copy]", form), saved = null;
      try { saved = JSON.parse(sessionStorage.getItem(KEY)); } catch (e) {}
      if (saved && copy) {
        copy.textContent = saved.text; copy.hidden = false;
        var num = $("[data-lr-number]"); if (num) num.textContent = saved.number;
      }
      var pr = $("[data-lr-print]", form); if (pr) pr.addEventListener("click", function () { window.print(); });
      return;
    }
    var minor = $("[data-lr-minor]", form), parent = $("[data-lr-parent]", form);
    if (minor && parent) minor.addEventListener("change", function () {
      parent.hidden = !minor.checked;
      var inp = $("input", parent); if (inp) inp.required = minor.checked;
    });
    form.addEventListener("submit", function () {
      var d = new Date(), pad = function (n) { return String(n).padStart(2, "0"); };
      var number = "LR-" + d.getFullYear() + pad(d.getMonth() + 1) + pad(d.getDate()) + "-" + pad(d.getHours()) + pad(d.getMinutes()) + pad(d.getSeconds());
      var field = $('[data-lr-field="number"]', form); if (field) field.value = number;
      var lines = ["Hoja de reclamación N° " + number, "Fecha: " + d.toLocaleString("es-PE"), ""];
      $$("input, select, textarea", form).forEach(function (el) {
        if (el.type === "hidden" || (el.type === "radio" && !el.checked) || (el.type === "checkbox" && !el.checked) || !el.value) return;
        var label = el.labels && el.labels[0] ? el.labels[0].textContent.trim() : (el.name || "").replace(/^contact\[|\]$/g, "");
        lines.push(label + ": " + el.value);
      });
      try { sessionStorage.setItem(KEY, JSON.stringify({ number: number, text: lines.join("\n") })); } catch (e) {}
    });
  }

  /* ---------- arranque y editor de temas ---------- */
  function init() {
    initHero(); initCatalog(); initProduct(); initRecommendations(); initLibro();
    readScroll();
    if (H) paintPanels();
  }
  init();
  requestAnimationFrame(frame);
  if (location.hash.length > 1 && isHome) {
    var target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
    if (target) setTimeout(function () { target.scrollIntoView(); }, 60);
  }
  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:unload", function () { setTimeout(init, 0); });
  document.addEventListener("shopify:block:select", function (e) {
    // En el editor, al elegir un mensaje de la portada, muéstralo
    var panel = e.target.closest && e.target.closest("[data-panel]");
    if (panel && H) { var i = H.panels.indexOf(panel); if (i > -1) { H.panels.forEach(function (p, j) { p.style.opacity = j === i ? 1 : 0; }); } }
  });
})();

/* PERAL — extras: regalo en el carrito y fecha estimada de entrega */
(function () {
  "use strict";
  function $(s, c) { return (c || document).querySelector(s); }
  var giftTimer;
  function saveGift(box) {
    var on = $("[data-gift-toggle]", box).checked, txt = $("[data-gift-text]", box);
    clearTimeout(giftTimer);
    giftTimer = setTimeout(function () {
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ attributes: { "Es para regalo": on ? "Sí" : "", "Dedicatoria": on && txt ? txt.value : "" } })
      }).catch(function () {});
    }, 350);
  }
  document.addEventListener("change", function (e) {
    var t = e.target; if (!t.matches || !t.matches("[data-gift-toggle]")) return;
    var box = t.closest("[data-gift]"), msg = $("[data-gift-box]", box);
    if (msg) msg.hidden = !t.checked;
    if (t.checked) { var ta = $("[data-gift-text]", box); if (ta) ta.focus({ preventScroll: true }); }
    saveGift(box);
  });
  document.addEventListener("input", function (e) {
    var t = e.target; if (!t.matches || !t.matches("[data-gift-text]")) return;
    saveGift(t.closest("[data-gift]"));
  });
  function addDays(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) n--; } return d; }
  function fmt(d) { return d.toLocaleDateString("es-PE", { weekday: "long", day: "numeric", month: "long" }).replace(",", ""); }
  function initEta() {
    var el = $("[data-eta]"); if (!el) return;
    var now = new Date(), a = addDays(now, 1), b = addDays(now, 3);
    var lima = $("[data-eta-lima]", el);
    if (lima) lima.innerHTML = "Pídelo hoy y recíbelo en <b>Lima y Callao</b> entre el <b>" + fmt(a) + "</b> y el <b>" + fmt(b) + "</b>.";
    el.hidden = el.getAttribute("data-available") !== "true";
  }
  initEta();
  document.addEventListener("shopify:section:load", initEta);
})();
